var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import { useAuth } from "../hooks/useAuth";
// 创建认证上下文
var AuthContext = createContext(null);
/**
 * 认证提供者组件
 */
export var AuthProvider = function (_a) {
    var children = _a.children;
    var authState = useAuth();
    return (_jsx(AuthContext.Provider, __assign({ value: authState }, { children: children })));
};
// 认证上下文Hook
export var useAuthContext = function () {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
};
export default AuthProvider;
